import ReactDOM from 'react-dom';
import { OrderMessage } from './App';
import './style.css';
ReactDOM.render(<OrderMessage />, document.getElementById('wps_rma_order_msg_react'));
